import { default as isGlobalSettingsMailbox } from 'owa-account-source-list-store/lib/utils/isGlobalSettingsMailbox';
import { logStartGreyError } from 'owa-analytics-start';
import type { MailboxInfo } from 'owa-client-types';
import { isRunningOnWorker } from 'owa-config';
import type { ReadOnlyAccountConfiguration } from '../store/schema/OwaSessionStore';
import { getAccountSettingsInternal } from '../utils/getAccountSettingsInternal';
import { makeEmptyAccountConfiguration } from '../utils/makeEmptyAccountConfiguration';
import { getLinkedLicensingMailboxConfig } from './getLinkedLicensingMailboxConfig';
import { isLicensingMailboxInfo } from 'owa-account-source-list-types/lib/utils/isLicensingMailboxInfo';
import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';

export const getAccountScopeUserSettings = (
    mailboxInfo: MailboxInfo,
    noGreyError?: boolean
): ReadOnlyAccountConfiguration => {
    // Intercept licensing mailbox requests and redirect to licensing mailbox config
    if (isLicensingMailboxInfo(mailboxInfo)) {
        const licensingConfig = getLinkedLicensingMailboxConfig(mailboxInfo);

        if (licensingConfig) {
            return toReadOnlyAccountConfiguration(licensingConfig);
        }
    }

    const settings = getAccountSettingsInternal(mailboxInfo);
    if (!settings && !noGreyError && isRunningOnWorker()) {
        logStartGreyError('AccountScopeUserSettingsMissing', mailboxInfo, undefined /*error*/, {
            isGlobalSettingsMailbox: isGlobalSettingsMailbox(mailboxInfo),
        });
    }
    return settings ?? makeEmptyAccountConfiguration();
};

function toReadOnlyAccountConfiguration(
    userConfiguration: OwaUserConfiguration
): ReadOnlyAccountConfiguration {
    return {
        ...userConfiguration,
        defaultFolderNameToIdMap: new Map(),
        defaultFolderIdToNameMap: new Map(),
    };
}
